import store from '@/store'

function getMatchedAccessRights(currentPath) {
    const list = store.state.user_apps_list
    if (!list) return null

    for (const item of list) {
        const match = item.appPages.find(x => currentPath.startsWith(x.pagePath))
        if (match) return match
    }

    return null
}

export function hasAddRights(currentPath) {
    const matched = getMatchedAccessRights(currentPath)
    return matched && matched.accessRights.add
}

export function hasEditRights(currentPath) {
    const matched = getMatchedAccessRights(currentPath)
    return matched && matched.accessRights.edit
}

export function hasDeleteRights(currentPath) {
    const matched = getMatchedAccessRights(currentPath)
    return matched && matched.accessRights.delete
}

export function hasApproverRights(currentPath) {
    const matched = getMatchedAccessRights(currentPath)
    return matched && matched.accessRights.approver
}

export function hasExportRights(currentPath) {
    const matched = getMatchedAccessRights(currentPath)
    return matched && matched.accessRights.export
}